import * as core from 'cw-ui-core';
import { GET } from 'src/services/ApiService';

export const loadFeatureFlags = async() => {
    const result = await GET('/Config/featureFlags');
    if (!result.isSuccess) {
        const error = 'Failed to load feature flags. ' + result.error;
        core.CwLog.error(error); 
        return;
    }
    let featureFlagResponse = result?.response ?? {}; 
    localStorage.setItem('FeatureFlags', JSON.stringify(featureFlagResponse)); 
};

export const getFeatureFlagsFromLocalStorage = () => {
    try {
    const featureFlags = localStorage.getItem('FeatureFlags');
    return featureFlags ? JSON.parse(featureFlags) : {};
    }
    catch (e) {
        console.warn("Invalid FeatureFlags in storage", e);
        return {};
    }
};